import { render } from "./BaseTextMessage.vue?vue&type=template&id=52b6bf63"
import script from "./BaseTextMessage.vue?vue&type=script&lang=js"
export * from "./BaseTextMessage.vue?vue&type=script&lang=js"

import "./BaseTextMessage.vue?vue&type=style&index=0&id=52b6bf63&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__